import React, { useState, useEffect, useMemo } from 'react';
import apis from '../../api';
import './index.less';
import { Divider, Tooltip, Spin, Radio, Button, message } from 'antd';
import ComponentLog from '@/components/component-log';
import PlatformWrapper from '../platform-wrapper';
import CheckList from './components/toCheck';
import SignupList from './components/toSignup';
import SalesList from './components/toSales';
import { withRouter } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import cacheData from './mockdata';
import utils from '@/common/utils';
import ReportProcess from '../report-process';
import { log, detailLog, exposureLog } from './log';
import Empty from '@/components/core-empty';

// 活动会场类型
// MARKETING_ACTIVITY(1, "默认会场活动"),
// STOCK_TAKING(101, "盘货"),
// POOL_ACTIVITY(105, "征品活动");

const MARKETING_ACTIVITY = 1;
const STOCK_TAKING = 101;
const POOL_ACTIVITY = 105;

function MyTodoList(props) {
  // 判断是否是采销
  const roleType = props.userMap.userType;
  const [isLoading, setIsLoading] = useState(false);
  const [tab, setTab] = useState('');
  // 表示‘我管理的--2’还是‘我参与的--1’标识 默认我发起的
  const [source, setSource] = useState('');
  const [data, setData] = useState('');
  const [firstLoading, setFirstLoading] = useState(true);

  const tabList = useMemo(() => {
    let _tabList = [
      {
        tab: 1,
        name: '招商报名',
      },
      {
        tab: 2,
        name: '会场活动',
      },
      {
        tab: 3,
        name: '综促活动',
      },
      {
        tab: 4,
        name: '频道',
      },
    ];
    if (roleType !== 2 && !window.localStorage.getItem('cache')) {
      _tabList = _tabList.slice(1);
    }
    if (props.showProcess) {
      _tabList.push({
        tab: 5,
        name: '会场收品进度',
      });
    }
    return _tabList;
  }, [roleType, props.showProcess]);

  // 主请求接口
  /* eslint-disable */
  useEffect(() => {
    if (firstLoading) return;
    setIsLoading(true);
    apis
      .getMyTodoList({ version: 2, source, tab })
      .then((res) => {
        res = window.localStorage.getItem('cache') ? cacheData : res;
        if (res.ret === '0' && res.data) {
          setData(res.data);
          // 曝光埋点操作
          const { applying = [], approval = [] } = res.data;
          let ids = [];
          applying.list.map((ele) => {
            ids.push(ele.activityId || ele.planCode);
          });
          approval.list.map((ele) => {
            ids.push(ele.activityId || ele.planCode);
          });
          exposureLog(tab, ids.join(','));
          //------------
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [source, tab]);
  /* eslint-enable */

  // 首次请求接口
  /* eslint-disable */
  useEffect(() => {
    if (!firstLoading) return;
    setIsLoading(true);
    apis
      .getMyTodoList({ version: 2 })
      .then((res) => {
        res = window.localStorage.getItem('cache') ? cacheData : res;
        if (res.ret === '0' && res.data) {
          const { display = '' } = res.data;
          if (display) {
            const { source = '', tab = '' } = display;
            setData(res.data);
            // 曝光埋点操作
            const { applying = [], approval = [] } = res.data;
            let ids = [];
            applying.list.map((ele) => {
              ids.push(ele.activityId || ele.planCode);
            });
            approval.list.map((ele) => {
              ids.push(ele.activityId || ele.planCode);
            });
            exposureLog(tab, ids.join(','));
            //------------
            setSource(source);
            tab && setTab(tab);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      })
      .finally(() => {
        setFirstLoading(false);
      });
  }, []);
  /* eslint-enable */

  // 判断活动类型，跳转不同的页面
  function urlsOfactivityType(item, url) {
    switch (item.activityType) {
      case MARKETING_ACTIVITY:
        return url;
      case STOCK_TAKING:
        return `/ph/phActivityDetail/enroll/signUp?id=${item.activityId}`;
      case POOL_ACTIVITY:
        return '';
      default:
        return url;
    }
  }

  function addVisualCheck(item, url) {
    if (item.areaRoleType && item.areaRoleType === 2) {
      return '/all-about-me/audit-material/audit-for-me';
    }
    return url;
  }

  // 我发起的链接集合
  function linksOfCreateSlef(item) {
    if (item) {
      if (item.activityVersion === 1) {
        return {
          toSignup: urlsOfactivityType(
            item,
            `/activity-manage/myCreate/pools/roomlist?entry=0&activityId=${item.activityId}&from=acore&hideTab=1&id=${item.activityId}`
          ),
          toCheck: addVisualCheck(
            item,
            `/activity-manage/myCreate/pools/roomlist?entry=0&activityId=${item.activityId}&blockId=${item.areaId}&from=acore&hideTab=1&id=${item.activityId}`
          ),
        };
      } else {
        return {
          toSignup: urlsOfactivityType(
            item,
            `/activity-manage/merchants/venueDetail/pools?planCode=${item.planCode}&roomId=${item.roomId}&entry=0&activityId=${item.activityId}`
          ),
          toCheck: addVisualCheck(
            item,
            `/activity-manage/merchants/venueDetail/pools?planCode=${item.planCode}&roomId=${item.roomId}&entry=0&activityId=${item.activityId}&blockId=${item.areaId}`
          ),
        };
      }
    }
    return {
      toSignupMore: '/activity-manage/myCreate/room/activityReceipt?tab=2',
      toCheckMore: '/all-about-me/audit-material/audit-for-me',
    };
  }
  // 我收到的连接合集
  function linksOfReceived(item) {
    if (item) {
      if (item.activityVersion === 1) {
        return {
          toSignup: urlsOfactivityType(
            item,
            `/activity-manage/myCreate/signUp?entry=1&activityId=${item.activityId}&blockId=${item.areaId}&gatherType=${item.gatherType}&resourceAssignType=1&from=acore#actHash`
          ),
          toCheck: addVisualCheck(
            item,
            `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${item.activityId}&blockId=${item.areaId}&from=acore&hideTab=1&id=${item.activityId}`
          ),
        };
      } else {
        return {
          toSignup: urlsOfactivityType(
            item,
            `/activity-manage/merchants/venueDetail/signUp?entry=1&activityId=${item.activityId}&blockId=${item.areaId}&gatherType=${item.gatherType}&resourceAssignType=1&planCode=${item.planCode}&roomId=${item.roomId}#actHash`
          ),
          toCheck: addVisualCheck(
            item,
            `/activity-manage/merchants/venueDetail/poolList?entry=1&planCode=${item.planCode}&roomId=${item.roomId}&activityId=${item.activityId}&blockId=${item.areaId}`
          ),
        };
      }
    }
    return {
      toSignupMore: '/activity-manage/myCreate/room/activityReceipt?tab=1',
      toCheckMore: '/all-about-me/audit-material/audit-for-me',
    };
  }

  const zongcuMoreLinks = () => {
    return '/activity-manage/myCreate/zongcuActivity/myCreate';
  };

  const toSalesSignup = (item) => {
    detailLog(tab, 0, item.planCode);
    if (!item.planCode) return;
    utils.goto(`/activity-manage/merchants/detail/myWare?planCode=${item.planCode}`, 'newTab');
  };

  const toZongcuSignUp = (item) => {
    detailLog(tab, 0, item.outActivityId);
    if (!item.planCode) {
      utils.goto(
        `/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail?activity_id=${item.outActivityId}`,
        'newTab'
      );
    } else {
      utils.goto(
        `/activity-manage/merchants/detail/promotion/myJoin/detail/activityEnroll/detail?activity_id=${item.outActivityId}&planCode=${item.planCode}`,
        'newTab'
      );
    }
  };

  const toZongcuSignupMore = () => {
    utils.goto('/activity-manage/myCreate/zongcuActivity/myJoin', 'newTab');
  };

  const links = source === 2 ? linksOfCreateSlef : linksOfReceived;

  function toCheck(item) {
    detailLog(tab, 1, item.activityId);
    if (!item.activityId || !item.areaId) return;
    utils.goto(links(item).toCheck, 'newTab');
  }

  function toSignup(item) {
    detailLog(tab, 0, item.activityId);
    if (!item.activityId || !item.areaId) return;
    utils.goto(links(item).toSignup, 'newTab');
  }

  function toCheckChannel(item) {
    detailLog(tab, 1, item.activityId);
    // 我参与的频道
    if (source === 1) {
      switch (item.channelType && item.channelType.toString()) {
        case '3': {
          utils.goto(
            addVisualCheck(
              item,
              `/platform-marketing/resource-detail/material-collection/distribute/roomlist?channelId=${item.channelId}&resourceId=${item.resourceId}&activityId=${item.activityId}&entry=1&hideTab=1&id=${item.activityId}`
            ),
            'newTab'
          );
          break;
        }
        case '4': {
          utils.goto(
            addVisualCheck(
              item,
              `/channel-service/position/resource-detail/material-collection/distribute/roomlist?channelId=${item.channelId}&resourceId=${item.resourceId}&activityId=${item.activityId}&entry=1&hideTab=1&id=${item.activityId}`
            ),
            'newTab'
          );
          break;
        }
        default: {
          return;
        }
      }
    } else if (source === 2) {
      // 我管理的频道
      switch (item.channelType.toString()) {
        case '3': {
          utils.goto(
            addVisualCheck(
              item,
              `/platform-marketing/resource-detail/material-collection/distribute/roomlist?channelId=${item.channelId}&resourceId=${item.resourceId}&activityId=${item.activityId}&entry=0&hideTab=1&id=${item.activityId}`
            ),
            'newTab'
          );
          break;
        }
        case '4': {
          utils.goto(
            addVisualCheck(
              item,
              `/channel-service/position/resource-detail/material-collection/distribute/roomlist?channelId=${item.channelId}&resourceId=${item.resourceId}&activityId=${item.activityId}&entry=0&hideTab=1&id=${item.activityId}`
            ),
            'newTab'
          );
          break;
        }
        default: {
          return;
        }
      }
    }
  }

  function toSignupChannel(item) {
    detailLog(tab, 0, item.activityId);
    if (source === 1) {
      // 我参与的频道 待报名
      switch (item.channelType && item.channelType.toString()) {
        case '3': {
          utils.goto(
            `/platform-marketing/resource-detail/material-collection/signUp?entry=1&activityId=${item.activityId}&blockId=${item.areaId}&gatherType=${item.gatherType}&resourceAssignType=${item.resourceAssignType}&channelId=${item.channelId}&resourceId=${item.resourceId}&from=acore#actHash`,
            'newTab'
          );
          break;
        }
        case '4': {
          utils.goto(
            `/channel-service/position/resource-detail/material-collection/signUp?entry=1&activityId=${item.activityId}&blockId=${item.areaId}&gatherType=${item.gatherType}&resourceAssignType=${item.resourceAssignType}&channelId=${item.channelId}&resourceId=${item.resourceId}&from=acore#actHash`,
            'newTab'
          );
          break;
        }
        default: {
          return;
        }
      }
    }
  }

  function toCheckChannelMore() {
    // 我参与 我管理是一个链接
    utils.goto(`/all-about-me/audit-material/audit-for-me`, 'newTab');
  }

  function toSignupMore() {
    utils.goto(links().toSignupMore, 'newTab');
  }

  function toCheckMore() {
    utils.goto(links().toCheckMore, 'newTab');
  }

  function toZongcuDetail(item) {
    if (!item.outActivityId) return;
    // history.push(zongcuDetailsLinks(item.outActivityId));
    if (!item.planCode) {
      utils.goto(
        `/activity-manage/myCreate/zongcuActivity/myCreate/detail/activityManage/detail?activity_id=${item.outActivityId}&flow_type=0`,
        'newTab'
      );
    } else {
      utils.goto(
        `/activity-manage/merchants/detail/promotion/myCreate/detail/activityManage/qualificationSetting?activity_id=${item.outActivityId}&planCode=${item.planCode}`,
        'newTab'
      );
    }
  }

  function toZongcuMore() {
    utils.goto(zongcuMoreLinks(), 'newTab');
  }

  function changeTab(value) {
    const val = value.target.value;
    setTab(val);
  }

  const TodoListFilter = () => {
    return (
      <div className="todolist-dropdown">
        <Tooltip title="其他人分给我的活动中需要处理的任务" arrowPointAtCenter overlayStyle={{ maxWidth: '260px' }}>
          <span
            style={{ cursor: 'pointer', marginRight: '32px' }}
            onClick={() => setSource(1)}
            className={source === 1 ? 'selected' : ''}
          >
            我参与的
          </span>
        </Tooltip>
        <Tooltip title="我创建的活动中需要处理的任务" arrowPointAtCenter>
          <span
            style={{ cursor: 'pointer', marginRight: '32px' }}
            onClick={() => setSource(2)}
            className={source === 2 ? 'selected' : ''}
          >
            我管理的
          </span>
        </Tooltip>
      </div>
    );
  };

  const salesContent = () => {
    return (
      <div className="operate-activity">
        <div className="salesList">
          {data.applying && data.applying.list.length > 0 ? (
            <SalesList salesList={data.applying.list} toSignup={toSalesSignup} btnText="去报名" />
          ) : (
            <div className="todo-list-empty">
              <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
            </div>
          )}
        </div>
      </div>
    );
  };

  const operateContent = () => {
    if (!data.applying) return;
    return (
      <div className="operate-activity">
        <div className="to-do-list-tab">
          {(source == 1 && data.applying.totalCount === 0 && data.approval.totalCount === 0) ||
          (source == 2 && data.approval.totalCount === 0) ? (
            <div className="todo-list-empty">
              <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
            </div>
          ) : (
            <>
              {source == 1 && (
                <>
                  <div className="signup">
                    {data.applying.totalCount != 0 && (
                      <div className="signup-title">
                        待报名&nbsp;
                        <span className="signup-num">
                          {data.applying.totalCount > 99 ? '99+' : data.applying.totalCount}
                        </span>
                        {data.applying.totalCount > 0 && (
                          <ComponentLog>
                            <div clstag="hd_gallery_1609139574203|1" className="toMore" onClick={toSignupMore}>
                              更多
                              <RightOutlined />
                            </div>
                          </ComponentLog>
                        )}
                      </div>
                    )}
                    <div className="signupList">
                      <SignupList
                        signupList={data.applying.list.slice(0, 2)}
                        source={source}
                        toSignup={toSignup}
                        signupNum={data.applying.totalCount}
                        btnText="去报名"
                        clstag="hd_gallery_1608781524403|1"
                      />
                    </div>
                  </div>
                  {data.approval.totalCount > 0 && <Divider />}
                </>
              )}
              <div className="tocheck">
                {data.approval.totalCount != 0 && (
                  <div className="tocheck-title">
                    待审核&nbsp;
                    <span className="tocheck-num">
                      {data.approval.totalCount > 99 ? '99+' : data.approval.totalCount}
                    </span>
                    {data.approval.totalCount > 0 && (
                      <ComponentLog>
                        <div className="toMore" clstag="hd_gallery_1606447516680|10" onClick={toCheckMore}>
                          更多
                          <RightOutlined />
                        </div>
                      </ComponentLog>
                    )}
                  </div>
                )}
                <div className="checkList">
                  <CheckList
                    checkList={data.approval.list.slice(0, 2)}
                    toCheck={toCheck}
                    checkNum={data.approval.totalCount}
                    btnText="去审核"
                    clstag="hd_gallery_1606447516680|9"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const zongcuContent = () => {
    if (!data.applying) return;
    return (
      <div className="operate-activity">
        <div className="to-do-list-tab">
          {(roleType === 2 && data.applying.totalCount === 0 && data.approval.totalCount === 0) ||
          (roleType !== 2 && data.approval.totalCount === 0) ? (
            <div className="todo-list-empty">
              <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
            </div>
          ) : (
            <>
              {roleType === 2 && (
                <>
                  <div className="signup">
                    {data.applying.totalCount != 0 && (
                      <div className="signup-title">
                        待报名&nbsp;
                        <span className="signup-num">
                          {data.applying.totalCount > 99 ? '99+' : data.applying.totalCount}
                        </span>
                        {data.applying.totalCount > 0 && (
                          <ComponentLog>
                            <div clstag="resource_1627030927203|43" className="toMore" onClick={toZongcuSignupMore}>
                              更多
                              <RightOutlined />
                            </div>
                          </ComponentLog>
                        )}
                      </div>
                    )}
                    <div className="signupList">
                      <SignupList
                        signupList={data.applying.list.slice(0, 2)}
                        source={2}
                        toSignup={toZongcuSignUp}
                        signupNum={data.applying.totalCount}
                        btnText="去报名"
                        clstag="resource_1627030927203|39"
                      />
                    </div>
                  </div>
                  {data.applying.totalCount > 0 && data.approval.totalCount > 0 && <Divider />}
                </>
              )}

              <div className="tocheck">
                {data.approval.totalCount != 0 && (
                  <div className="tocheck-title">
                    待处理&nbsp;
                    <span className="tocheck-num">
                      {data.approval.totalCount > 99 ? '99+' : data.approval.totalCount}
                    </span>
                    {data.approval.totalCount > 0 && (
                      <ComponentLog>
                        <div clstag="resource_1627030927203|41" className="toMore" onClick={toZongcuMore}>
                          更多
                          <RightOutlined />
                        </div>
                      </ComponentLog>
                    )}
                  </div>
                )}
                <div className={roleType !== 2 ? 'signupList zongcu' : 'signupList'}>
                  <SignupList
                    signupList={roleType === 2 ? data.approval.list.slice(0, 2) : data.approval.list.slice(0, 5)}
                    toSignup={toZongcuDetail}
                    source={2}
                    signupNum={data.approval.totalCount}
                    btnText="去处理"
                    clstag="resource_1627030927203|40"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const channelContent = () => {
    if (!data.applying) return;
    return (
      <div className="operate-activity">
        <div className="to-do-list-tab">
          {(source == 1 && data.applying.totalCount === 0 && data.approval.totalCount === 0) ||
          (source == 2 && data.approval.totalCount === 0) ? (
            <div className="todo-list-empty">
              <Empty style={{ color: 'rgba(0,0,0,0.82)' }} />
            </div>
          ) : (
            <>
              {source == 1 && (
                <>
                  <div className="signup">
                    {data.applying.totalCount != 0 && (
                      <div className="signup-title">
                        待报名&nbsp;
                        <span className="signup-num">
                          {data.applying.totalCount > 99 ? '99+' : data.applying.totalCount}
                        </span>
                      </div>
                    )}
                    <div className="signupList">
                      <SignupList
                        signupList={data.applying.list.slice(0, 2)}
                        source={source}
                        toSignup={toSignupChannel}
                        signupNum={data.applying.totalCount}
                        btnText="去报名"
                        type="channel"
                      />
                    </div>
                  </div>
                  {data.approval.totalCount > 0 && <Divider />}
                </>
              )}

              <div className="tocheck">
                {data.approval.totalCount != 0 && (
                  <div className="tocheck-title">
                    待审核&nbsp;
                    <span className="tocheck-num">
                      {data.approval.totalCount > 99 ? '99+' : data.approval.totalCount}
                    </span>
                    {data.approval.totalCount > 0 && (
                      <ComponentLog>
                        <div className="toMore" clstag="hd_gallery_1606447516680|10" onClick={toCheckChannelMore}>
                          更多
                          <RightOutlined />
                        </div>
                      </ComponentLog>
                    )}
                  </div>
                )}
                <div className="checkList">
                  <CheckList
                    checkList={source == 2 ? data.approval.list.slice(0, 4) : data.approval.list.slice(0, 2)}
                    toCheck={toCheckChannel}
                    checkNum={data.approval.totalCount}
                    btnText="去审核"
                    type="channel"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <PlatformWrapper
      id="step1"
      title={
        <div className="todolist-filter">
          <Radio.Group onChange={changeTab} value={tab} size="small">
            {tabList.map((item) => (
              <Radio.Button key={item.tab} value={item.tab} onClick={() => log(item.tab)}>
                {item.name}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      }
      background="#EEF4FF"
      className="todo-list-wrapper"
      wrapperRight={<AllReportableActivityBtn {...props} />}
    >
      {tab === 2 && <div className="todolist-role-filter">{TodoListFilter()}</div>}
      {tab === 4 && <div className="todolist-role-filter">{TodoListFilter()}</div>}

      <Spin spinning={isLoading} style={{ height: '300px' }}>
        {tab === 1 && salesContent()}
        {tab === 2 && operateContent()}
        {tab === 3 && zongcuContent()}
        {tab === 4 && channelContent()}
        {tab === 5 && <ReportProcess exposureLog={(id) => exposureLog(tab, id)} />}
      </Spin>
    </PlatformWrapper>
  );
}

const AllReportableActivityBtn = (props) => {
  const menus = props.menus || [];
  // // 找出待办事项的menu
  // const menu_57 = menus.filter((item) => item.menuId == 57)[0];
  // // 找出是否有活动报名menu
  // const showReportBtn = menu_57 && menu_57.menus.find((ele) => ele.menuId == 75);

  let showReportBtn = findId(menus, 75);

  function findId(list = [], id) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].menuId === id) {
        return true;
      } else if (list[i].menus && list[i].menus.length) {
        findId(list[i].menus, id);
      }
    }
  }

  return showReportBtn ? (
    <Button
      type="primary"
      shape="round"
      onClick={() => {
        props.history.push('/all-about-me/signed-activity/reportable-activities');
        log('6');
      }}
    >
      全部可报活动
    </Button>
  ) : null;
};

export default connect((state) => state.userInfo)(withRouter(MyTodoList));
